/**
 * Labstep
 *
 * @module components/Sequence/Action/Update
 */

import SequenceActionEdit from 'labstep-web/components/Sequence/Action/Edit';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { SequenceEditor } from 'labstep-web/core/SequenceEditor';
import type React from 'react';
import styles from './styles.module.scss';
import type { ISequencePreviewProps } from './types';

const actionComponentProps = {
  type: 'icon',
  icon: 'external',
  elementProps: { color: 'blue' },
  text: '',
} as ActionComponentProps;

export const SequencePreview: React.FC<ISequencePreviewProps> = ({
  sequence,
  expandIconComponent,
}) => (
  <div className={styles.container}>
    <div className={styles.fullscreenAction}>
      {expandIconComponent ? (
        expandIconComponent({ actionComponentProps })
      ) : (
        <SequenceActionEdit
          sequence={sequence}
          actionComponentProps={actionComponentProps}
        />
      )}
    </div>
    <SequenceEditor
      withPreviewMode
      sequenceData={sequence.sequenceData}
      readOnly
    />
  </div>
);
